import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UsuarioService } from 'src/app/services/usuario.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-my-account-email',
    templateUrl: './my-account-email.component.html',
    styleUrls: ['./my-account-email.component.css'],
    standalone: false
})
export class MyAccountEmailComponent implements OnInit  {
  private _authService = inject(AuthService);
  private _router = inject(Router);
  private _location = inject(Location);
  private _loadingService = inject(LoadingService);
  private _usuarioService = inject(UsuarioService);

  // ===== estado (signals) =====
  error = signal<string>('');

  // Señales derivadas (computed) desde tu UsuarioService
  email = computed(() => this._usuarioService.usuario().x_email ?? '');

  async ngOnInit() {
    // subir al top (como antes)
    document.documentElement.scrollTop = 0;

    // Si necesitás (re)cargar usuario/cliente desde backend, hacelo bajo el loader:
    await this._loadingService.run(async () => {
      try {
        // Asegura bootstrap de sesión (idempotente, ok en web/nativo)
        await this._authService.ensureSession();

        // Si ya tenemos email en el signal, nada más que hacer
        if (this.email()) return;

        // reconstruir email base (signal -> LS -> Firebase web)
        const fallbackEmail =
          this.email() ||
          localStorage.getItem('email') ||
          this._authService.currentUser()?.email || // en nativo suele ser null
          '';

        if (!fallbackEmail) return;

        
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu email.');
      }
    });
  }
  
  back(){
    this._location.back();
  }
}
